import React from 'react';

export const Arrow: React.FC<{ color?: string }> = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="8"
      height="16"
      viewBox="0 0 8 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.9375 8C7.93722 8.32917 7.81111 8.64578 7.585 8.885L0.76 15.875L0.0625 15.17L6.88 8.18C6.97917 8.08049 6.97917 7.91951 6.88 7.82L0.0625 0.83L0.76 0.125L7.585 7.115C7.81243 7.35338 7.93876 7.67054 7.9375 8Z" />
    </svg>
  );
};
